import { render, staticRenderFns } from "./OfferJobs.vue?vue&type=template&id=971cd940&"
import script from "./OfferJobs.vue?vue&type=script&lang=js&"
export * from "./OfferJobs.vue?vue&type=script&lang=js&"
import style0 from "./OfferJobs.vue?vue&type=style&index=0&id=971cd940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports